import React from 'react';
import { GameInterface } from '../constants/GameInterface';
import GameHeader from '../GameHeader';
import { Player } from '../classes/Player';
import { Round } from '../classes/Round';
import { RoundPhase } from '../constants/RoundPhase';
import { Popups } from '../constants/Popups';
import { Stats } from '../classes/Stats';
import { Hand } from '../classes/Hand';
import { RoundBlackCard } from '../classes/RoundBlackCards';
import { getBlackCardText, getRedCardText, getTimerText } from '../utils/TextsUtils';

interface PlayBlackCardsDialogInterface {
    statsId: number;
    currentPlayer: Player;
    setCurrentPlayer: any;
    currentRound: Round;
    judge: Player;
    criminal: Player;
    timeInSeconds: number;
    popup: Popups;
    getBlackCardSubmitTime: any;
}

function PlayBlackCardsDialog({statsId, currentPlayer, setCurrentPlayer, currentRound, judge, criminal, timeInSeconds, popup, getBlackCardSubmitTime}: PlayBlackCardsDialogInterface) {
    const leftArrowIcon = require("../images/redLeftArrow.png");
    const rightArrowIcon = require("../images/redRightArrow.png");
    const submitIcon = require("../images/submit.png");

    const getPunishmentTitleText = (criminalName: string) => {
        return "Choose karma for " + criminalName;
    }

    const handleSelectBlackCard = async () => {
        const submitTimeInSeconds = getBlackCardSubmitTime();
        const removedArr =  currentPlayer.hand.indices.splice(currentPlayer.hand.leadingCardIdx, 1);
        if (removedArr.length === 1) {
            const blackCardIdx = removedArr[0];
            Stats.updatePlayedPunishmentCards(statsId, blackCardIdx, submitTimeInSeconds);

            // updating the player's hand
            let indicesStr = "";
            for (let idx = 0; idx < currentPlayer.hand.indices.length; idx++) {
                const blackCardIndex = currentPlayer.hand.indices[idx];
                indicesStr += blackCardIndex + ",";
            }

            await Hand.updateHand(currentPlayer.id, indicesStr);
    
            // updating round black cards
            await RoundBlackCard.updatePlayerRoundBlackCardIdx(currentPlayer.id, blackCardIdx);
        }
    }

    const handleLeftArrowClick = () => {
        const leadingCardIdx = currentPlayer.hand.leadingCardIdx;
        if (leadingCardIdx === 0) {
            return;
        }

        const tempCurrentPlayer = currentPlayer.clone();
        tempCurrentPlayer.hand.setLeadingCardIdx(leadingCardIdx - 1);
        setCurrentPlayer(tempCurrentPlayer);
    }

    const handleRightArrowClick = () => {
        const leadingCardIdx = currentPlayer.hand.leadingCardIdx;
        if (leadingCardIdx === 6) {
            return;
        }

        const tempCurrentPlayer = currentPlayer.clone();
        tempCurrentPlayer.hand.setLeadingCardIdx(leadingCardIdx + 1);
        setCurrentPlayer(tempCurrentPlayer);
    }

    return (
        <div className="playBlackCardsOuterWrapper">
            <div className="playBlackCardsWrapper">
                <div className="playBlackCardsMiddle">
                    <div className="playBlackCardsRedCardTextWrapper">
                        <div className="playBlackCardsRedCardText">
                            {getRedCardText(currentRound.redCardIdx, criminal.name, criminal.gender)}
                        </div>
                    </div>
                    <div className="playBlackCardsJudgeTimerWrapper">
                        <div className="playBlackCardsJudge">
                            {"Judge: " + judge.name}
                        </div>
                        <div className="playBlackCardsTimer">
                            {getTimerText(timeInSeconds)}
                        </div>
                    </div>
                </div>
                <div className="playBlackCardsBottom">
                    <div className="playBlackCardsChooseKarma">
                        {getPunishmentTitleText(criminal.name)}
                    </div>
                    <div className="playBlackCardsHandWrapper">
                        {currentPlayer.hand.leadingCardIdx === 0 || currentPlayer.hand.leadingCardIdx === 1
                            ? <div className="playBlackCardsCard1Hide"></div>
                            : <div className="playBlackCardsCard1">
                                <div className="playBlackCardsSideCardText"></div>
                            </div>
                        }
                        {currentPlayer.hand.leadingCardIdx === 0
                            ? <div className="playBlackCardsCard2Hide"></div>
                            : <div className="playBlackCardsCard2">
                                <div className="playBlackCardsSideCardText">
                                {
                                    currentPlayer.hand.leadingCardIdx - 1 >= 0 && currentPlayer.hand.leadingCardIdx - 1 < currentPlayer.hand.indices.length
                                        ? getBlackCardText(currentPlayer.hand.indices[currentPlayer.hand.leadingCardIdx - 1], criminal.name, criminal.gender)
                                        : ""
                                }
                                </div>
                            </div>
                        }
                        
                        <div className="playBlackCardsCard3">
                            <div className="playBlackCardsMainCardText">
                                {
                                    currentPlayer.hand.leadingCardIdx >= 0 && currentPlayer.hand.leadingCardIdx < currentPlayer.hand.indices.length
                                        ? getBlackCardText(currentPlayer.hand.indices[currentPlayer.hand.leadingCardIdx], criminal.name, criminal.gender)
                                        : ""
                                }
                            </div>
                            {popup === Popups.none && <div className="playBlackCardsSubmit" tabIndex={0} onClick={handleSelectBlackCard} onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    handleSelectBlackCard();
                                }
                            }}>
                                <img className="playBlackCardsSubmitIcon" src={submitIcon} alt="submit black card"/>
                            </div>}
                            {popup === Popups.none && <div className="playBlackCardsArrowsWrapper">
                                {currentPlayer.hand.leadingCardIdx > 0
                                    ? <div className="playBlackCardsLeftArrow" tabIndex={0} onClick={handleLeftArrowClick} onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            handleLeftArrowClick();
                                        }
                                    }}>
                                        <img className="playBlackCardsLeftArrowIcon" src={leftArrowIcon} alt="left arrow"/>
                                    </div>
                                    : <div/>
                                }
                                {currentPlayer.hand.leadingCardIdx < currentPlayer.hand.indices.length - 1
                                    ? <div className="playBlackCardsRightArrow" tabIndex={0} onClick={handleRightArrowClick} onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            handleRightArrowClick();
                                        }
                                    }}>
                                        <img className="playBlackCardsRightArrowIcon" src={rightArrowIcon} alt="right arrow"/>
                                    </div>
                                    : <div/>
                                }
                            </div>}
                        </div>
                        {currentPlayer.hand.leadingCardIdx === 6
                            ? <div className="playBlackCardsCard4Hide"></div>
                            : <div className="playBlackCardsCard4">
                                <div className="playBlackCardsSideCardText">
                                {
                                    currentPlayer.hand.leadingCardIdx + 1 >= 0 && currentPlayer.hand.leadingCardIdx + 1 < currentPlayer.hand.indices.length
                                        ? getBlackCardText(currentPlayer.hand.indices[currentPlayer.hand.leadingCardIdx + 1], criminal.name, criminal.gender)
                                        : ""
                                }
                                </div>
                            </div>
                        }
                        {currentPlayer.hand.leadingCardIdx === 5 || currentPlayer.hand.leadingCardIdx === 6
                            ? <div className="playBlackCardsCard5Hide"></div>
                            : <div className="playBlackCardsCard5">
                                <div className="playBlackCardsSideCardText"></div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlayBlackCardsDialog;